export default __webpack_public_path__ + "static/media/ngo-a036-example-en.504aa0ab.png";